import { EmblaCarouselType } from 'embla-carousel';
import { ChevronRight } from 'lucide-react';
import { Dispatch, SetStateAction, useCallback } from 'react';

import { cn } from '@/utilities/cn';

interface ICarouselNextButtonProps {
  emblaApi: EmblaCarouselType | undefined,
  setSelectedIndex: Dispatch<SetStateAction<number>>,
  contents: any[],
  selectedIndex: number,
  loop: boolean,
}

const CarouselNextButton = (props: ICarouselNextButtonProps) => {
  const { emblaApi, contents, selectedIndex, setSelectedIndex, loop } = props;

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi, setSelectedIndex]);

  const onClickNext = () => {
    if (!emblaApi?.canScrollNext()) return;
    emblaApi?.scrollNext();
    onSelect();
    loop && emblaApi?.plugins()?.autoplay?.play();
  };

  return (
    <button
      className={cn(
        'p-1 bg-white rounded-xl cursor-pointer border-1 border-solid border-secondary-600',
        'absolute z-10 right-5 top-1/2 -translate-y-1/2',
        'transition-all duration-150 delay-100',
        'hover:bg-secondary-100 disabled:bg-neutral-300 disabled:cursor-not-allowed',
        'sm:right-7.5',
        'md:p-2 md:border-2 '
      )}
      onClick={onClickNext}
      disabled={selectedIndex === contents.length - 1 && !loop}
      aria-label='Next'
    >
      <ChevronRight className='text-secondary-600' />
    </button>
  );
};

export default CarouselNextButton;
